import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="forms--file-field"
export default class extends Controller {
  static values = { upperLimit: Number, whitelist: Array };
  static targets = ["clientErrors", "serverErrors"];

  clearErrors() {
    if (this.hasServerErrorsTarget) {
      this.serverErrorsTarget.remove();
    }

    this.clientErrorsTarget.innerHTML = "";
  }

  checkFormat(event) {
    const format = event.target.files[0].type;

    if (!this.whitelistValue.includes(format)) {
      if (!this.clientErrorsTarget.classList.contains("mt-2")) {
        this.clientErrorsTarget.classList.add("mt-2");
      }
      const element = document.createElement("li");
      element.textContent = "File should be an image";
      this.clientErrorsTarget.append(element);
    }
  }

  checkSize(event) {
    const size = event.target.files[0].size;

    if (size > this.upperLimitValue) {
      if (!this.clientErrorsTarget.classList.contains("mt-2")) {
        this.clientErrorsTarget.classList.add("mt-2");
      }
      const element = document.createElement("li");
      element.textContent = "File should not be bigger than 5 MB in size";
      this.clientErrorsTarget.append(element);
    }
  }
}
